import React from 'react'

import Loader from 'react-loader-spinner'

import useI18n from 'i18n/useI18n'

import styled from 'theme/styled-components'
import useTheme from 'theme/useTheme'

import mapApi from 'map/mapApi'

import TotemMap from './TotemMap'
import Logger from 'utils/Logger'

const POI_REFRESH_INTERVAL = 3600 // 3600 seconds = 60 min = 1 hour

const TotemMapScreen = () => {
  const i18n = useI18n()
  const [theme] = useTheme()

  const [isLoading, setIsLoading] = React.useState(true)
  const [error, setError] = React.useState(false)

  const query = new URLSearchParams(location.search)
  const { siteId, defaultPOI, inactivityTimeout } = {
    siteId: query.get('siteId') ?? undefined,
    defaultPOI: query.get('defaultPOI') ?? undefined,
    inactivityTimeout: query.get('inactivityTimeout') ?? undefined,
  }

  const [siteHash, setSiteHash] = React.useState<string>('')
  const [areas, setAreas] = React.useState<TotemAreaV6[]>([])
  const [buildings, setBuildings] = React.useState<TotemBuildingV6[]>([])

  React.useEffect(() => {
    if (siteId) {
      mapApi
        .getTotemMap(siteId, i18n.lang)
        .then((response) => {
          setSiteHash(response.mapHash)
          setAreas(response.areas)
          setBuildings(response.buildings)
        })
        .catch((error) => {
          setError(true)
          Logger.error('TotemMapScreen', 'Error fetching totem map', error)
          setSiteHash('')
        })
        .finally(() => {
          setIsLoading(false)
        })

      setInterval(() => {
        mapApi
          .getTotemMap(siteId, i18n.lang)
          .then((response) => {
            setSiteHash(response.mapHash)
            setAreas(response.areas)
          })
          .catch(Logger.error)
      }, POI_REFRESH_INTERVAL * 1000)
    }
  }, [])

  return (
    <MainContainer>
      {isLoading ? (
        <Loader type="Grid" color={theme.colors.blue} height={150} width={150} />
      ) : !siteId || error ? (
        <ErrorMessage>{`${i18n.t('common.error')}: ${i18n.t('screens.cartography.totem.noSite')}`}</ErrorMessage>
      ) : (
        <TotemMap
          hashMap={siteHash}
          areas={areas}
          buildingsLocations={buildings.sort((a, b) => a.name.localeCompare(b.name))}
          defaultPOI={defaultPOI}
          inactivityTimeout={parseInt(inactivityTimeout!)}
        />
      )}
    </MainContainer>
  )
}

export default TotemMapScreen

const MainContainer = styled('div')`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`

const ErrorMessage = styled('p')`
  ${(props) => props.theme.fonts.totemBigLight};
  color: ${(props) => props.theme.colors.red};
  text-align: center;
  margin: auto;
`
